import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { usePreferences } from '../context/PreferencesContext';
import { Label } from './ui/label';

const OPTIONS = [
  { value: 'light', icon: Sun, tk: 'settings.theme_light' },
  { value: 'dark', icon: Moon, tk: 'settings.theme_dark' },
  { value: 'system', icon: Monitor, tk: 'settings.theme_system' },
];

export const ThemeToggle = ({ withLabel = true }) => {
  const { t } = useTranslation();
  const { preferences, setTheme } = usePreferences();
  return (
    <div className="space-y-2" data-testid="theme-toggle">
      {withLabel && (
        <Label className="text-sm text-text-secondary">{t('settings.theme')}</Label>
      )}
      <div
        role="radiogroup"
        aria-label={t('settings.theme')}
        className="grid grid-cols-3 gap-2 p-1 bg-background border border-border rounded-md"
      >
        {OPTIONS.map(({ value, icon: Icon, tk }) => {
          const active = preferences.theme === value;
          return (
            <button
              key={value}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => setTheme(value)}
              data-testid={`theme-option-${value}`}
              className={`flex items-center justify-center gap-2 px-3 py-2 rounded text-sm transition-colors ${
                active
                  ? 'bg-primary/15 text-primary border border-primary/40'
                  : 'text-text-secondary hover:bg-surface-elevated'
              }`}
            >
              <Icon className="w-4 h-4" />
              <span>{t(tk)}</span>
            </button>
          );
        })}
      </div>
      {withLabel && (
        <p className="text-xs text-text-muted">{t('settings.theme_help')}</p>
      )}
    </div>
  );
};
